module.exports = __webpack_public_path__ + "img/logo-dark.9b812577.svg";